import React from 'react';

/**
 * Lightweight full-page loading spinner used as Suspense fallback.
 */
const Loading = ({ label = 'Loading…' }) => (
  <div
    role="status"
    aria-live="polite"
    style={{
      minHeight: '50vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
    }}
  >
    <div
      style={{
        width: 48,
        height: 48,
        border: '4px solid #eee',
        borderTopColor: '#667eea',
        borderRadius: '50%',
        animation: 'spin 0.9s linear infinite',
      }}
    />
    <span style={{ color: '#666' }}>{label}</span>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

export default Loading;
